import { html } from 'lit';
const Help =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m.239 8.733c-.923.725-1.245 1.183-1.245 1.99 0 .437.274.765.773.765.478 0 .656-.273.827-.676.157-.575.383-.814 1.046-1.32.875-.65 1.456-1.23 1.456-2.29 0-1.524-1.251-2.46-3.049-2.46-.97 0-1.716.252-2.215.676-.41.362-.676.84-.676 1.292 0 .376.239.684.67.684.287 0 .45-.13.662-.41.329-.561.78-.814 1.436-.814.752 0 1.347.444 1.347 1.114 0 .602-.37.93-1.033 1.45m-.472 3.726c-.567 0-1.032.396-1.032.964 0 .567.465.964 1.032.964s1.039-.397 1.039-.964c0-.568-.472-.964-1.04-.964" clip-rule="evenodd"/>
  </svg>
`;
export default Help;
